module.exports = __webpack_public_path__ + "static/img/adv_icon2.4176649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/adv_icon2.png
// module id = jLiP
// module chunks = 1